import { useCallback } from 'react';

import { useSafeIsNavigationReady, useSafeNavigation, useSafeRouter } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

/**
 * Goes back within the stack if possible, otherwise goes back to the main stack.
 */
export const useNavigateBack = () => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const router = useSafeRouter();
  const navigation = useSafeNavigation();
  const isNavigationReady = useSafeIsNavigationReady();

  return useCallback(() => {
    if (isExpoRouterEnabled) {
      requestIdleCallback(() => {
        if (!isNavigationReady) return;

        setTimeout(() => {
          if (router?.canGoBack()) {
            router?.back();

            return;
          }

          router?.dismissTo('/');
        });
      });

      return;
    }

    if (navigation?.canGoBack()) {
      navigation.goBack();

      return;
    }

    navigation?.getParent()?.goBack();
  }, [isExpoRouterEnabled, isNavigationReady, router, navigation]);
};
